import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd5d2006"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Muestra orgánica de referencia", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_5 = {
  key: 1,
  style: {"margin-top":"10px"}
}
const _hoisted_6 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Muestra sintética de referencia", -1))
const _hoisted_8 = { style: {"margin-top":"10px","text-align":"left"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" + Añadir dato sintético ")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_12 = {
  key: 1,
  style: {"margin-top":"10px"}
}
const _hoisted_13 = {
  key: 0,
  style: {"margin-top":"12px"}
}
const _hoisted_14 = { style: {"margin-top":"20px","text-align":"right"} }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Guardar ")

import { ref, computed, onMounted, watch, shallowRef, nextTick, reactive } from "vue";
import { getvisualizeTrainingData } from "@/service/trainingData.service";
import { getSamplingPointById } from "@/service/samplingpoint.service";
import { addImageTrainingRelations, getImageTrainingRelationsLabel } from "@/service/image.service";
import type { SamplingPoint } from "@/types/samplingpoint.type";
import type { Filter } from "@/types/filter.type";
import type { ImageLabelData } from "@/types/Image.type";
import type { TrainingData } from "@/types/trainingData.type";
import { ElMessage } from "element-plus";
import { isMoment } from "moment";
import { useRoute } from "vue-router";
import { Container } from "@/types/container.type";
import { getParameter } from "@/service/parameter.service";
import { Parameter } from "@/types/parameter.type";
import SyntheticDataForm from "@/components/issueMonitoring/imageLabel/SyntheticDataForm.vue";

type FormFilter = {
  samplingPoint: SamplingPoint;
  fromDateTime: Date;
  toDateTime: Date;
  numberImageLabel: number;
  type: string;
};

export default /*#__PURE__*/_defineComponent({
  props: {
    formFilter: null,
    image: null,
    images: null,
    imagesrc: null,
    labels: null
  },
  emits: ["sampleConflictUpdate"],
  setup(__props: any, { emit }: { emit: ({
  (e: "sampleConflictUpdate", payload: { imageId: number; sampleId: number }[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  formFilter: FormFilter;
  image: ImageLabelData;
  images?: Array<ImageLabelData>;
  imagesrc?: Record<string, string>;
  labels?: Array<ImageLabelData>;
}

const dialogVisible = ref(false);

const container = ref<Container>();
const parameters = ref<Parameter[]>([]);

const isNewOrganic = ref(false);
const isNewAqua = ref(false);
const loading = ref(false);
const route = useRoute();
const correctRoute = route.path === "/issue-monitoring/samplingpoints/FQConfig";

const selectedOrganicOrigin = ref<string | null>(null);

const organicOrigins = [
  "DUERO",
  "LABORATORIO",
  "MULTIPARAMETRICA",
  "SAK",
  "SCADA",
  "SCRAPPING",
  "SONDA_DQO",
  "OTRO",
];



const newSyntheticData = ref<TrainingData>({
  dateTime: null,
  raw: 0,
  clean: undefined,
  value: 0,
  magnitude: "",
  origin: "SINTETICO",
  status: "ORIGINAL",
  samplingPointType: "",
  container: {},
  codeParameter: {} as Parameter,
  event: undefined,
});



const trainingData = shallowRef<TrainingData[]>([]);
const trainingDataLabels = ref<Record<number, string>>({});

const getTagType = (status: string) => {
  switch (status) {
    case "CLOSEST":
      return "success";
    case "EXTRA":
      return "info";
    case "MANUAL":
      return "warning";
    default:
      return "info";
  }
};
// const aquaData = computed(() => trainingData.value.filter((d) => d.origin === "AQUACORP"));
const aquaData = computed(() => trainingData.value.filter((d) => d.origin === "SINTETICO"));
const organicData = computed(() => {
  return trainingData.value.filter((d) => {
    // if (d.origin === "AQUACORP") return false;
    if (d.origin === "SINTETICO" || d.origin === "AQUACORP") return false;
    if (!selectedOrganicOrigin.value) return true;
    return d.origin === selectedOrganicOrigin.value;
  });
});

const groupByDate = (data: TrainingData[]) => {
  const groups: Record<string, TrainingData[]> = {};
  data.forEach((item) => {
    const d = new Date(item.dateTime);
    const dateKey = d.toLocaleString("es-ES", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
    if (!groups[dateKey]) groups[dateKey] = [];
    groups[dateKey].push(item);
  });
  return groups;
};

const groupedAquaData = computed(() => groupByDate(aquaData.value));
const groupedOrganicData = computed(() => groupByDate(organicData.value));

const selectedAquaDate = ref<string | null>(null);
const selectedOrganicDate = ref<string | null>(null);

const selectedAquaIds = computed(() =>
  selectedAquaDate.value
    ? groupedAquaData.value[selectedAquaDate.value]?.map((i) => i.id) ?? []
    : []
);
const selectedOrganicIds = computed(() =>
  selectedOrganicDate.value
    ? groupedOrganicData.value[selectedOrganicDate.value]?.map((i) => i.id) ?? []
    : []
);

const getTrainingDataById = (id: number) => trainingData.value.find((d) => d.id === id);

const fetchTrainingData = async () => {
  if (!props.formFilter?.samplingPoint?.id || !props.image?.dateTime) {
    trainingData.value = [];
    return;
  }

  try {
    const sp = await getSamplingPointById(props.formFilter.samplingPoint.id);
    container.value = sp.container;

    let imageDate: Date = isMoment(props.image.dateTime)
      ? props.image.dateTime.toDate()
      : new Date(props.image.dateTime);
    const startDate = new Date(imageDate.getTime() - 60 * 60 * 1000);
    const endDate = new Date(imageDate.getTime() + 60 * 60 * 1000);
    const filter: Filter = {
      fields: {
        "trainingData.container": { operator: "equal", value: sp.container?.id },
        "trainingData.dateTime": {
          operator: "between",
          value: [startDate.toISOString(), endDate.toISOString()],
        },
      },
    };

    const response = await getvisualizeTrainingData(undefined, undefined, filter);

    const data = response.data ?? [];

    trainingData.value = data;
  } catch (err) {
    console.error("Error trayendo training data:", err);
    trainingData.value = [];
  }
};

const sampleToSource: Record<
  number,
  { sourceImageId: number; sourceDate: Date; sourceTypology: string | null }
> = reactive({});
const conflictsByImageId: Record<number, Set<number>> = reactive({});

// ms
const ONE_HOUR_MS = 60 * 60 * 1000;

function parseDate(val: string | Date | undefined) {
  if (!val) return null;
  return typeof val === "string" ? new Date(val) : new Date(val);
}

function registerSamplesForImage(
  imageId: number,
  sampleIds: number[],
  typology: string | null,
  dateTime: string | Date | undefined
) {
  const srcDate = parseDate(dateTime);
  if (!srcDate) return;
  for (const sId of sampleIds) {
    if (!sId) continue;
    sampleToSource[sId] = {
      sourceImageId: imageId,
      sourceDate: srcDate,
      sourceTypology: typology ?? null,
    };
  }
}

function recomputeAllConflicts() {
  Object.keys(conflictsByImageId).forEach((k) => delete conflictsByImageId[+k]);

  if (!props.images || !Array.isArray(props.images)) return;

  const imagesList = props.images as any[];

  Object.entries(sampleToSource).forEach(([sampleIdStr, info]) => {
    const sampleId = +sampleIdStr;
    const srcDate = info.sourceDate;
    const srcTypo = info.sourceTypology;

    imagesList.forEach((img) => {
      if (!img?.id || !img?.dateTime) return;
      const imgDate = parseDate(img.dateTime);
      if (!imgDate) return;

      const diff = Math.abs(imgDate.getTime() - srcDate.getTime());
      if (diff <= ONE_HOUR_MS) {
        // const imgTypo = (img as any)?.nameTmoa ?? null;
        // if (srcTypo && imgTypo && imgTypo !== srcTypo) {
        //   if (!conflictsByImageId[img.id]) conflictsByImageId[img.id] = new Set();
        //   conflictsByImageId[img.id].add(sampleId);
        // }
        const imgTypo = img?.imageLabel?.label ?? null;
        if (srcTypo && imgTypo && imgTypo !== srcTypo) {
          if (!conflictsByImageId[img.id]) {
            conflictsByImageId[img.id] = new Set();
          }
          conflictsByImageId[img.id].add(sampleId);
        }
      }
    });
  });

  const payload: { imageId: number; sampleId: number }[] = [];
  Object.entries(conflictsByImageId).forEach(([imgIdStr, set]) => {
    const imageId = +imgIdStr;
    set.forEach((sId) => payload.push({ imageId, sampleId: sId }));
  });
}

function conflictsCountForCurrentImage() {
  if (!props.image?.id) return 0;
  const s = conflictsByImageId[props.image.id];
  return s ? s.size : 0;
}

const getStatusOfSelectedDate = (
  dateKey: string | null,
  groupedData: Record<string, TrainingData[]>
) => {
  if (!dateKey || !groupedData[dateKey]) return null;
  const firstItem = groupedData[dateKey][0];
  return trainingDataLabels.value[firstItem.id || 0] || null;
};

// const loadImageRelations = async () => {
//   if (!props.image?.id) return;

//   try {
//     const { sinteticos = [], organicos = [] } = await getImageTrainingRelations(props.image.id);

//     const sampleIds = [...(sinteticos ?? []), ...(organicos ?? [])].filter(Boolean) as number[];
//     // const typology = (props.image as any)?.nameTmoa ?? null;
//     const typology = props.image?.imageLabel?.label ?? null;

//     registerSamplesForImage(props.image.id, sampleIds, typology, props.image?.dateTime);

//     recomputeAllConflicts();

//     const aquaKeys = Object.keys(groupedAquaData.value).filter((date) =>
//       groupedAquaData.value[date].some((item) => sinteticos.includes(item.id))
//     );
//     const organicKeys = Object.keys(groupedOrganicData.value).filter((date) =>
//       groupedOrganicData.value[date].some((item) => organicos.includes(item.id))
//     );

//     const localIsNewAqua = aquaData.value.length > 0 ? sinteticos.length === 0 : false;
//     const localIsNewOrganic = organicData.value.length > 0 ? organicos.length === 0 : false;

//     const localSelectedAquaDate = aquaKeys.length
//       ? aquaKeys[0]
//       : localIsNewAqua && props.image?.dateTime
//       ? findDateKeyForGroup(
//           groupedAquaData.value,
//           findClosestDateGroup(aquaData.value, new Date(props.image.dateTime))
//         )
//       : null;

//     const localSelectedOrganicDate = organicKeys.length
//       ? organicKeys[0]
//       : localIsNewOrganic && props.image?.dateTime
//       ? findDateKeyForGroup(
//           groupedOrganicData.value,
//           findClosestDateGroup(organicData.value, new Date(props.image.dateTime))
//         )
//       : null;

//     isNewAqua.value = localIsNewAqua;
//     isNewOrganic.value = localIsNewOrganic;
//     selectedAquaDate.value = localSelectedAquaDate;
//     selectedOrganicDate.value = localSelectedOrganicDate;
//   } catch (err) {
//     console.error("Error cargando relaciones de la imagen", err);
//   }
// };
const loadImageRelations = async () => {
  if (!props.image?.id) return;

  try {
    const { sinteticos = [], organicos = [] } = await getImageTrainingRelationsLabel(
      props.image.id
    );

    const sinteticosIds = sinteticos.map((s: any) => s.id);
    const organicosIds = organicos.map((o: any) => o.id);

    const labelsMap: Record<number, string> = {};
    sinteticos.forEach((s: any) => {
      labelsMap[s.id] = s.status;
    });
    organicos.forEach((o: any) => {
      labelsMap[o.id] = o.status;
    });
    trainingDataLabels.value = labelsMap;

    const sampleIds = [...sinteticosIds, ...organicosIds];
    const typology = props.image?.imageLabel?.label ?? null;

    registerSamplesForImage(props.image.id, sampleIds, typology, props.image?.dateTime);
    recomputeAllConflicts();

    const aquaKeys = Object.keys(groupedAquaData.value).filter((date) =>
      groupedAquaData.value[date].some((item) => sinteticosIds.includes(item.id))
    );
    const organicKeys = Object.keys(groupedOrganicData.value).filter((date) =>
      groupedOrganicData.value[date].some((item) => organicosIds.includes(item.id))
    );

    const localIsNewAqua = aquaData.value.length > 0 ? sinteticos.length === 0 : false;
    const localIsNewOrganic = organicData.value.length > 0 ? organicos.length === 0 : false;

    const localSelectedAquaDate = aquaKeys.length
      ? aquaKeys[0]
      : localIsNewAqua && props.image?.dateTime
      ? findDateKeyForGroup(
          groupedAquaData.value,
          findClosestDateGroup(aquaData.value, new Date(props.image.dateTime))
        )
      : null;

    const localSelectedOrganicDate = organicKeys.length
      ? organicKeys[0]
      : localIsNewOrganic && props.image?.dateTime
      ? findDateKeyForGroup(
          groupedOrganicData.value,
          findClosestDateGroup(organicData.value, new Date(props.image.dateTime))
        )
      : null;

    isNewAqua.value = aquaData.value.length > 0 ? sinteticosIds.length === 0 : false;
    isNewOrganic.value = organicData.value.length > 0 ? organicosIds.length === 0 : false;
    selectedAquaDate.value = localSelectedAquaDate;
    selectedOrganicDate.value = localSelectedOrganicDate;
  } catch (err) {
    console.error("Error cargando relaciones de la imagen", err);
  }
};

const saveData = async () => {
  try {
    if (!props.image?.id) return ElMessage.error("No hay imagen seleccionada");
    // if (conflictsCountForCurrentImage() > 0) {
    //   ElMessage.error(
    //     "Esta muestra ya está asociada a otra imagen dentro de ±1 hora"
    //   );
    //   return;
    // }

    const sinteticos = selectedAquaIds.value;
    const organicos = selectedOrganicIds.value;
    await addImageTrainingRelations(props.image.id, sinteticos, organicos);
    ElMessage.success("Datos guardados correctamente");
    await loadDataForImage();

    const sampleIds = [...(sinteticos ?? []), ...(organicos ?? [])].filter(Boolean) as number[];
    // const typology = (props.image as any)?.nameTmoa ?? null;
    const typology = props.image?.imageLabel?.label ?? null;

    registerSamplesForImage(props.image.id, sampleIds, typology, props.image?.dateTime);
    recomputeAllConflicts();
  } catch (error) {
    console.error("Error al guardar relación:", error);
    ElMessage.error("Error guardando relaciones.");
  }
};

const findClosestDateGroup = (data: TrainingData[], targetDate: Date): TrainingData[] => {
  if (!data.length) return [];

  const dateMap: Record<string, TrainingData[]> = {};
  data.forEach((item) => {
    const d = new Date(item.dateTime);
    const dateKey = d.toLocaleString("es-ES", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
    if (!dateMap[dateKey]) dateMap[dateKey] = [];
    dateMap[dateKey].push(item);
  });

  let closestDateKey = Object.keys(dateMap)[0];
  let minDiff = Math.abs(
    new Date(dateMap[closestDateKey][0].dateTime).getTime() - targetDate.getTime()
  );

  for (const key of Object.keys(dateMap)) {
    const diff = Math.abs(new Date(dateMap[key][0].dateTime).getTime() - targetDate.getTime());
    if (diff < minDiff) {
      minDiff = diff;
      closestDateKey = key;
    }
  }

  return dateMap[closestDateKey];
};

const findDateKeyForGroup = (grouped: Record<string, TrainingData[]>, group: TrainingData[]) => {
  if (!group?.length) return null;
  const id0 = group[0].id;
  return Object.keys(grouped).find((key) => grouped[key].some((it) => it.id === id0)) ?? null;
};

const loadDataForImage = async () => {
  loading.value = true;
  try {
    await fetchTrainingData();
    await loadImageRelations();
    await nextTick();
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  loadDataForImage();

  parameters.value = (await getParameter(undefined, undefined, undefined))?.data;
});

watch(() => props.formFilter?.samplingPoint?.id, fetchTrainingData, { immediate: true });
watch(() => props.image, loadDataForImage, { immediate: true });
watch(
  () => newSyntheticData.value.codeParameter,
  (newParamCode) => {
    if (!newParamCode) {
      newSyntheticData.value.magnitude = "";
      return;
    }

    newSyntheticData.value.magnitude = newSyntheticData.value.codeParameter.name || "";
  }
);

watch(
  () => props.images,
  (newImgs) => {
    console.log("NEW IMGS", newImgs);
    recomputeAllConflicts();
  },
  { immediate: true, deep: true }
);
watch(
  () => props.imagesrc,
  (newImgs) => {
    console.log("NEW SRC", newImgs);
  },
  { immediate: true, deep: true }
);
watch(
  () => props.labels,
  (newImgs) => {
    console.log("NEW LABELS", newImgs);
  },
  { immediate: true, deep: true }
);

const conflictSampleIdsSet = computed(() => {
  if (!props.image?.id) return new Set<number>();
  const s = conflictsByImageId[props.image.id];
  return s ? new Set(Array.from(s)) : new Set<number>();
});

function groupHasConflict(group: any[]) {
  if (!group || !Array.isArray(group)) return false;
  const set = conflictSampleIdsSet.value;
  if (!set || set.size === 0) return false;
  return group.some((item) => item && item.id && set.has(item.id));
}
watch(
  () => dialogVisible.value,
  (open) => {
    if (!open) return;

    const imgDate = props.image?.dateTime;

    if (!imgDate) {
      newSyntheticData.value.dateTime = new Date().toISOString();
      return;
    }

    newSyntheticData.value.dateTime =
      imgDate instanceof Date
        ? new Date(imgDate).toISOString()
        : isMoment(imgDate)
        ? imgDate.toDate().toISOString()
        : new Date(imgDate).toISOString();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_spin = _resolveComponent("el-spin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_spin, {
        spinning: loading.value,
        tip: "Loading..."
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, {
            gutter: 24,
            style: {"margin-top":"20px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "never" }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _hoisted_2,
                        _createElementVNode("span", {
                          style: _normalizeStyle({
                    display: 'inline-block',
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    backgroundColor: isNewOrganic.value
                      ? '#144382'
                      : selectedOrganicDate.value
                      ? '#FF9500'
                      : '#B0B0B0',
                  })
                        }, null, 4)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: selectedOrganicOrigin.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOrganicOrigin).value = $event)),
                        placeholder: "Selecciona origen",
                        style: {"width":"100%","margin-bottom":"10px"},
                        clearable: "",
                        disabled: !correctRoute
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(organicOrigins, (origin) => {
                            return _createVNode(_component_el_option, {
                              key: origin,
                              label: origin,
                              value: origin
                            }, null, 8, ["label", "value"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_select, {
                        modelValue: selectedOrganicDate.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOrganicDate).value = $event)),
                        placeholder: "Selecciona una fecha",
                        style: {"width":"100%"},
                        clearable: "",
                        disabled: !correctRoute
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupedOrganicData), (group, date) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: date,
                              value: date,
                              disabled: groupHasConflict(group)
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass({ 'conflict-option-text': groupHasConflict(group) })
                                }, [
                                  _createTextVNode(_toDisplayString(`${date} | ${group.length} registro(s) | ${group[0].origin}`) + " ", 1),
                                  (groupHasConflict(group))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ]),
                              _: 2
                            }, 1032, ["value", "disabled"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"]),
                      (selectedOrganicDate.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupedOrganicData)[selectedOrganicDate.value], (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.id
                              }, [
                                _createElementVNode("p", null, [
                                  _createElementVNode("strong", null, _toDisplayString(item.codeParameter?.name ?? "Parámetro") + ":", 1),
                                  _createTextVNode(" " + _toDisplayString(item.raw ?? item.value ?? item.clean ?? "—") + " - " + _toDisplayString(item.origin), 1)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (selectedOrganicDate.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (getStatusOfSelectedDate(selectedOrganicDate.value, _unref(groupedOrganicData)))
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  type: 
                  getTagType(getStatusOfSelectedDate(selectedOrganicDate.value, _unref(groupedOrganicData)) || '')
                ,
                                  effect: "dark"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(getStatusOfSelectedDate(selectedOrganicDate.value, _unref(groupedOrganicData))), 1)
                                  ]),
                                  _: 1
                                }, 8, ["type"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 24,
                style: {"margin-top":"15px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "never" }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("span", {
                          style: _normalizeStyle({
                    display: 'inline-block',
                    width: '12px',
                    height: '12px',
                    borderRadius: '12px',
                    backgroundColor: isNewAqua.value
                      ? '#144382'
                      : selectedAquaDate.value
                      ? '#FF9500'
                      : '#B0B0B0',
                  })
                        }, null, 4)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "small",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (dialogVisible.value = true)),
                          style: {"width":"100%"},
                          disabled: !correctRoute
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: selectedAquaDate.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedAquaDate).value = $event)),
                        placeholder: "Selecciona una fecha",
                        style: {"width":"100%"},
                        clearable: "",
                        disabled: !correctRoute
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupedAquaData), (group, date) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: date,
                              value: date,
                              disabled: groupHasConflict(group)
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass({ 'conflict-option-text': groupHasConflict(group) })
                                }, [
                                  _createTextVNode(_toDisplayString(`${date} | ${group.length} registro(s) ${group[0].origin}`) + " ", 1),
                                  (groupHasConflict(group))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ]),
                              _: 2
                            }, 1032, ["value", "disabled"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"]),
                      (selectedAquaDate.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupedAquaData)[selectedAquaDate.value], (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.id
                              }, [
                                _createElementVNode("p", null, [
                                  _createElementVNode("strong", null, _toDisplayString(item.codeParameter?.name ?? "Parámetro") + ":", 1),
                                  _createTextVNode(" " + _toDisplayString(item.raw ?? item.value ?? item.clean ?? "—") + " - " + _toDisplayString(item.origin), 1)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (selectedAquaDate.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (getStatusOfSelectedDate(selectedAquaDate.value, _unref(groupedAquaData)))
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  type: getTagType(getStatusOfSelectedDate(selectedAquaDate.value, _unref(groupedAquaData)) || ''),
                                  effect: "dark"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(getStatusOfSelectedDate(selectedAquaDate.value, _unref(groupedAquaData))), 1)
                                  ]),
                                  _: 1
                                }, 8, ["type"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (conflictsCountForCurrentImage() > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_el_alert, {
                  type: "warning",
                  description: `Hay ${conflictsCountForCurrentImage()} muestra(s) asignada(s) a imágenes de otra etiqueta dentro de ±1h.`,
                  "show-icon": ""
                }, null, 8, ["description"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: saveData,
              disabled: !correctRoute
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _: 1
      }, 8, ["spinning"])
    ]),
    _createVNode(SyntheticDataForm, {
      visible: dialogVisible.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((dialogVisible).value = $event)),
      "default-date": __props.image?.dateTime,
      container: container.value,
      "available-parameters": parameters.value,
      onSaved: fetchTrainingData
    }, null, 8, ["visible", "default-date", "container", "available-parameters"])
  ], 64))
}
}

})